import { useEffect, useState } from "react";
import QuestionList from "../QuestionList";
import "./SliderComponent.css";
import "./AssignmentQuestionPanel.css";

const AssignmentQuestionPanel = ({ open, onClose, onConfirm, existingIds = [], existingObjects = [] }) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [removedIds, setRemovedIds] = useState([]);
  const [objectsMap, setObjectsMap] = useState({});

  useEffect(() => {
    if (open) {
      setSelectedIds([...existingIds]);
      setRemovedIds([]);
      const map = {};
      existingObjects.forEach(q => { map[q._id] = q; });
      setObjectsMap(map);
    }
  }, [open, existingIds, existingObjects]);

  const handleSelectedChange = (ids, objects) => {
    setSelectedIds(ids);
    if (objects) {
      setObjectsMap(prev => {
        const next = { ...prev };
        objects.forEach(q => { next[q._id] = q; });
        Object.keys(next).forEach(id => { if (!ids.includes(id)) delete next[id]; });
        return next;
      });
    }
  };

  // QuestionList passes the full new array, not a single id
  const handleRemoveChange = (newList) => setRemovedIds(Array.isArray(newList) ? newList : []);

  const handleConfirm = () => {
    const objects = selectedIds.map(id => objectsMap[id]).filter(Boolean);
    onConfirm(selectedIds, removedIds, objects);
    onClose();
  };

  return (
    <>
      <div className={`Slider-overlay ${open ? "show" : ""}`} onClick={onClose} />
      <div className={`slider-panel ${open ? "open" : ""}`}>
        <div className="slider-header">
          <h2 className="slider-title">Select Questions</h2>
          <div className="aqp-header-actions">
            <button className="aqp-confirm-btn" onClick={handleConfirm}>
              Add Questions{selectedIds.length > 0 ? ` (${selectedIds.length})` : ""}
            </button>
            <button className="aqp-close-btn" onClick={onClose}>✕</button>
          </div>
        </div>
        <div className="slider-content">
          <QuestionList
            showCheckbox
            selectedChange={selectedIds}
            onSelectedChange={handleSelectedChange}
            previouslySelected={existingIds}
            removeChanged={removedIds}
            onRemoveChanged={handleRemoveChange}
          />
        </div>
      </div>
    </>
  );
};

export default AssignmentQuestionPanel;
